import { useContext } from 'react';
import { AtlasAuthContext } from './AtlasAuthProvider';

export const useAtlasAuth = () => {
	const context = useContext(AtlasAuthContext);

	if (context === undefined) {
		throw new Error('AtlasAuthContext must be used within a AtlasAuthProvider');
	}

	return context;
};
export default useAtlasAuth;
